import type { GetServerSideProps } from 'next';
import feature_tanabata from '../../../public/images/feature_tanabata.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> =
  async (ctx) => {
    const { commonFeatureGetServerSideProps } = await import(
      '../../server/features/commonFeatureServerSideProps'
    );
    return commonFeatureGetServerSideProps(ctx);
  };

export default createFeatureNamePage({
  slug: 'tanabata',
  featureName: '七夕',
  title: '⭐七夕限定メニュー特集⭐',
  description: `恋愛成就や願望成就のエネルギーが高まる1週間に
あなたの今のお悩みを特別メニューで占ってみませんか？🎋`,
  ogImageUrl: 'https://raysee.jp/images/feature_tanabata.png',
  heroImage: feature_tanabata,
});
